import SpriteSymbol from "../../../node_modules/_svg-baker-runtime@1.4.7@svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/_svg-sprite-loader@5.2.1@svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-page_back",
  "use": "icon-page_back-usage",
  "viewBox": "0 0 10 20",
  "content": "<symbol viewBox=\"0 0 10 20\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-page_back\">\n<g clip-path=\"url(#icon-page_back_clip0_4849_202970)\">\n<path d=\"M10 2L2 10L10 18\" stroke=\"#81818A\" stroke-width=\"2\" stroke-linecap=\"square\" />\n</g>\n<defs>\n<clipPath id=\"icon-page_back_clip0_4849_202970\">\n<rect width=\"10\" height=\"20\" fill=\"white\" />\n</clipPath>\n</defs>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol